import CommunitiesLayout from "./Layout"
import MessagesApp from "../../communities/pages/messages/App"

const Messages = (props) => {
  return <MessagesApp />
}
Messages.layout = (page) => <CommunitiesLayout>{page}</CommunitiesLayout>
export default Messages
